export default __webpack_public_path__ + "static/media/dimension-logo.47ef8a13.svg";